import { useState } from 'react';
import { useEditVersionContext } from '@/context/EditVersionContext/useEditVersionContext.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { get_automation_version_schemas_url } from '@/utils/urls.ts';
import { AutomationVersion } from '@/types/automations.ts';
import { AutomationJsonSchema } from '@/types/automationFields.ts';
import { notifyStepMutationError } from '@/services/stepMutationErrors.ts';

type UpdateAutomationVersionSchemasParams = {
  updater: (schemas: AutomationJsonSchema[]) => AutomationJsonSchema[];
};

const useUpdateAutomationVersionSchemas = () => {
  const apiClient = useApiClient();
  const { addToQueue } = useEditVersionContext();
  const [pendingCount, setPendingCount] = useState(0);

  const updateSchemas = (params: UpdateAutomationVersionSchemasParams) => {
    setPendingCount((count) => count + 1);
    addToQueue<AutomationVersion, unknown>({
      mutationFn: async (latestVersion) => {
        const schemas = params.updater(latestVersion.schemas ?? []);
        const response = await apiClient.put(
          get_automation_version_schemas_url(latestVersion.id),
          { schemas },
          { suppressGlobalErrorToast: true },
        );
        return response.data;
      },
      onSuccess: () => {},
      onError: (error) => notifyStepMutationError('update schemas', error, () => {}),
      onComplete: () => setPendingCount((count) => Math.max(count - 1, 0)),
    });
  };

  return { mutate: updateSchemas, isPending: pendingCount > 0 };
};

export default useUpdateAutomationVersionSchemas;
